import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase-config";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../../assets/styles/AdminShared.css';

const AdminCustomDomain = () => {
  const { projectId } = useParams(); // Get project ID from URL
  const [customDomain, setCustomDomain] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCustomDomain = async () => {
      try {
        if (!projectId) throw new Error("Project ID is missing.");

        const projectRef = doc(db, "projects", projectId);
        const projectSnap = await getDoc(projectRef);

        if (projectSnap.exists()) {
          const projectData = projectSnap.data();
          setCustomDomain(projectData.customDomain || "No domain submitted yet.");
        } else {
          throw new Error("Project not found.");
        }
      } catch (error) {
        console.error("Error fetching custom domain:", error.message);
        toast.error("Failed to load custom domain. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomDomain();
  }, [projectId]);

  return (
    <div className="ap-page ap-page--narrow">
      <ToastContainer />
      <div className="ap-page-header">
        <a href="/admin" className="ap-back">← Back to dashboard</a>
        <p className="ap-eyebrow">Admin</p>
        <h1 className="ap-title">Custom Domain</h1>
        <p className="ap-subtitle">View the custom domain submitted for this project.</p>
      </div>

      {loading ? (
        <div className="ap-loading"><p>Loading...</p></div>
      ) : (
        <div className="ap-section">
          <div className="ap-section-header">
            <h2 className="ap-section-title">Custom Domain</h2>
          </div>
          <div className="ap-section-body">
            {customDomain !== "No domain submitted yet." ? (
              <div className="ap-link-display"><strong>{customDomain}</strong></div>
            ) : (
              <p className="ap-empty"><em>{customDomain}</em></p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCustomDomain;
